import { useLocalReactionStore } from "designSystem/hooks";
import React, { FunctionComponent } from "react";
import SustainabilityProfileView from "./SustainabilityProfileView";
import { SustainabilityProfileStore, SustainabilityProfileStoreContext } from "./SustainabilityProfileStore";

const ConnectToSustainabilityProfile: FunctionComponent = () => {
	const sustainabilityProfileStore = useLocalReactionStore(() => new SustainabilityProfileStore());

	return (
		<SustainabilityProfileStoreContext.Provider value={sustainabilityProfileStore}>
			{sustainabilityProfileStore &&
				<SustainabilityProfileView />
			}
		</SustainabilityProfileStoreContext.Provider>
	);
};

export default ConnectToSustainabilityProfile;
